import React, { useEffect } from 'react';
import { ErrorMessage, Field } from 'formik';

const AddressFinderField = ({ setFieldValue, values, handleChange }) => {
  let widget;
  const initAddressFinder = function () {
    widget = new AddressFinder.Widget(document.getElementById('address'), 'YNRXQAPTLDHVJEW73GUC', 'NZ', {
      address_params: {},
    });
    widget.on('address:select', function (fullAddress, metaData) {
      const selected = new AddressFinder.NZSelectedAddress(fullAddress, metaData);
      setFieldValue('address', selected.fullAddress);
      if (values.friendsArray) {
        let i;
        for (i = 0; i < values.friendsArray.length; i++) {
          if (
            document.getElementById(`friend-${i}-same-address`) &&
            document.getElementById(`friend-${i}-same-address`).checked
          ) {
            setFieldValue(`friendsArray[${i}][address]`, selected.fullAddress);
          }
        }
      }
    });
  };

  const downloadAddressFinder = () => {
    const script = document.createElement('script');
    script.src = 'https://api.addressfinder.io/assets/v3/widget.js';
    script.async = true;
    script.onload = initAddressFinder;
    document.body.appendChild(script);
  };

  useEffect(() => {
    downloadAddressFinder();
  }, []);

  return (
    <li className="form-field">
      <label className="required">Address:</label>
      <Field
        name="address"
        type="text"
        id="address"
        autoComplete="nope"
        placeholder="Start typing address or postcode"
        onChange={(e) => {
          handleChange(e);
          if (values.level == 'friend') {
            let i;
            for (i = 0; i < values.friendsArray.length; i++) {
              if (document.getElementById(`friend-${i}-same-address`).checked) {
                setFieldValue(`friendsArray[${i}][address]`, e.target.value);
              }
            }
          }
        }}
      />
      {/* <Field */}
      {/*  name="postcode" */}
      {/*  type="text" */}
      {/*  id="postcode" */}
      {/*  placeholder="postcode" */}
      {/*  onKeyUp={() => { */}
      {/*    setFieldValue('postcode', ''); */}
      {/*  }} */}
      {/* /> */}
      <ErrorMessage name="address">
        {(msg) => (
          <ul className="validationErrors">
            <li id="address-error" className="formValidationError">
              {msg}
            </li>
          </ul>
        )}
      </ErrorMessage>
    </li>
  );
};

export default AddressFinderField;
